import { http } from '../../http/client';
import type { Bank } from './bank';
import type { BankBranch } from './bankBranch';

export function fetchBanks(): Promise<Bank[]> {
  return http.get<Bank[]>('/api/v1/banks.json');
}

export function fetchBankBranches(bankId: number): Promise<BankBranch[]> {
  return http.get<BankBranch[]>('/api/v1/bank_branches.json', {
    params: {
      bank_id: bankId,
    },
  });
}
